import { HousingInfo } from "../models/housingInfo.ts"
import { Mechanics } from "../models/mechanicsConfiguration.ts";

const housingDetails: Record<string, HousingInfo> = {
  S2: {
    image: "/mechanics/S2.png",
    maxModules: 2,
    deviceSize: "185 x 150 x 270 mm",
    dutX: 130,
    dutY: 120,
  },
  S2B: {
    image: "/mechanics/S2B.png",
    maxModules: 2,
    deviceSize: "185 x 180 x 270 mm",
    dutX: 130,
    dutY: 120,
  },
  M2: {
    image: "/mechanics/M2.png",
    maxModules: 4,
    deviceSize: "240 x 150 x 270 mm",
    dutX: 190,
    dutY: 120,
  },
  M2B: {
    image: "/mechanics/M2B.png",
    maxModules: 4,
    deviceSize: "240 x 180 x 270 mm",
    dutX: 190,
    dutY: 120,
  },
  L2: {
    image: "/mechanics/L2.png",
    maxModules: 6,
    deviceSize: "300 x 150 x 270 mm",
    dutX: 250,
    dutY: 120,
  },
  L2B: {
    image: "/mechanics/L2B.png",
    maxModules: 6,
    deviceSize: "300 x 180 x 270 mm",
    dutX: 250,
    dutY: 120,
  },
  L3: {
    image: "/mechanics/L3.png",
    maxModules: 10,
    deviceSize: "300 x 205 x 270 mm",
    dutX: 250,
    dutY: 175,
  },
  L3B: {
    image: "/mechanics/L3B.png",
    maxModules: 10,
    deviceSize: "300 x 235 x 270 mm",
    dutX: 250,
    dutY: 175,
  },
};
export const getHousingInfo = (data: Mechanics): HousingInfo => {
  const key = data.housing.toUpperCase() + (data.user_interface ? "B" : "");
  return housingDetails[key];
}